import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { useMainMenuContext } from "../MainMenu/hooks";
import DashboardMenuDesktop from "./layout/DashboardMenuDesktop";
import DashboardMenuMobile from "./layout/DashboardMenuMobile";
import { jsx as _jsx } from "react/jsx-runtime";
var DashboardMenu = function DashboardMenu(_ref) {
  var feedbackUrl = _ref.feedbackUrl;
  var _useMainMenuContext = useMainMenuContext(),
    currentBreakpointKey = _useMainMenuContext.currentBreakpointKey,
    layoutConfig = _useMainMenuContext.layoutConfig,
    onDashboardSearchClick = _useMainMenuContext.onDashboardSearchClick;
  var dashboardMenuLayoutProps = {
    shouldRenderSearch: !!onDashboardSearchClick && !layoutConfig.hideSearch,
    feedbackUrl: feedbackUrl
  };
  return currentBreakpointKey === 'xs' ? /*#__PURE__*/_jsx(DashboardMenuMobile, _objectSpread({}, dashboardMenuLayoutProps)) : /*#__PURE__*/_jsx(DashboardMenuDesktop, _objectSpread({}, dashboardMenuLayoutProps));
};
export default DashboardMenu;